// src/components/ProductForm.js
import React, { useState, useEffect } from "react";
import "../styles/Forms.css";
import "../styles/Buttons.css";

const ProductForm = ({ initialData, onSubmit }) => {
  const [productData, setProductData] = useState({
    product_code: initialData?.product_code || "",
    product_short_code: initialData?.product_short_code || "",
    product_name: initialData?.product_name || "",
    package_quantity: initialData?.package_quantity || 0,
    net_weight: initialData?.net_weight || "",
    shelf_life: initialData?.shelf_life || 0,
    brand: initialData?.brand || "",
    is_traceable: initialData?.is_traceable ?? true,
  });

  useEffect(() => {
    setProductData(initialData);
  }, [initialData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setProductData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e, productData);
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <label>Product Code:</label>
      <input
        type="text"
        name="product_code"
        value={productData.product_code}
        onChange={handleChange}
        disabled
      />


      <label>Product Name:</label>
      <input
        type="text"
        name="product_name"
        value={productData.product_name}
        onChange={handleChange}
        required
      />

      <label>Package Quantity:</label>
      <input
        type="number"
        name="package_quantity"
        value={productData.package_quantity}
        onChange={handleChange}
        required
      />

      <label>Net Weight:</label>
      <input
        type="text"
        name="net_weight"
        value={productData.net_weight}
        onChange={handleChange}
        required
      />

      <label>Shelf Life (Months):</label>
      <input
        type="number"
        name="shelf_life"
        value={productData.shelf_life}
        onChange={handleChange}
        required
      />

      <label>Brand:</label>
      <input
        type="text"
        name="brand"
        value={productData.brand}
        onChange={handleChange}
      />

      <label>Is Traceable?</label>
      <select
        name="is_traceable"
        value={productData.is_traceable}
        onChange={handleChange}
      >
        <option value="true">Yes</option>
        <option value="false">No (Delete Product)</option>
      </select>

      <p className="info-text">
        *Product code cannot be changed once created. Please delete and
        re-create if needed.
      </p>

      <button type="submit">Save Changes</button>
    </form>
  );
};

export default ProductForm;
